var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3 16.3c1.8 1.6 3.4 2.6 3.4 2.6.1 0 .2.1.2.1.1 0 .2 0 .2-.1.1 0 1.7-1.1 3.4-2.6 1-.9 1.9-1.8 2.6-2.7.9-1.1 1.4-2.2 1.6-3.2.1-.3.1-.7.1-1v-.1c0-1.2-.5-2.2-1.3-3-.8-.8-1.9-1.3-3-1.3-.9 0-1.8.3-2.6.9-.5.3-.8.8-1.1 1.2-.3-.5-.7-.9-1.1-1.2-.6-.6-1.5-.9-2.4-.9-1.1 0-2.2.5-3 1.3-.8.8-1.3 1.9-1.3 3v.1c0 .3 0 .7.1 1 .2 1 .8 2.1 1.6 3.2.7.9 1.6 1.8 2.6 2.7z"
  })));
}

export default SvgHeart;